import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

const initialState = {
  loading: false,
  addCustomerData: {},
  error: "",
  success: false,
  status: "",
};

const addCustomerCall = createAsyncThunk(
  "customer/addCustomer",
  async (data) => {
    try {
      const result = await axios.post(
        "https://apac.api.capillarytech.com/mobile/v2/api/customer/add?format=json",
        data
      );
  
      return result?.data;
    } catch (err) {
      console.log(err);
    }
  }
);

const addCustomerSlice = createSlice({
  name: "add-customer",
  initialState,
  reducers: {
    reset: (state, payload) => {
      state.loading = false;
      state.success = false;
      state.error = "";
    },
  },
  extraReducers: (builder) => {
    builder.addCase(addCustomerCall.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(addCustomerCall.fulfilled, (state, action) => {
   
      state.loading = false;
      state.addCustomerData = action.payload?.customers?.customer[0];
      state.success = action.payload?.status.success === "true" ? true : false;
      state.error = "";
    });
    builder.addCase(addCustomerCall.rejected, (state, action) => {
      state.loading = false;
      state.addCustomerData = {};
      state.error = action.error.message;
      state.success = false;
    });
  },
});

export default addCustomerSlice.reducer;
export const { reset } = addCustomerSlice.actions;
export { addCustomerCall };
